import { render, staticRenderFns } from "./ExportPageEdgeText.vue?vue&type=template&id=df8f3298&scoped=true"
import script from "./ExportPageEdgeText.vue?vue&type=script&lang=js"
export * from "./ExportPageEdgeText.vue?vue&type=script&lang=js"
import style0 from "./ExportPageEdgeText.vue?vue&type=style&index=0&id=df8f3298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8f3298",
  null
  
)

export default component.exports